import { useSetAtom } from 'jotai';
import { useRouter } from 'next/router';
import { useCallback } from 'react';

import { intercomUnreadCountState } from '~/state/layouts/OrganizationAppShell/atoms';

const IGNORE_PATHNAME = [
  '/signup',
  '/signin',
  '/client_certs/[clientCertId]/download',
  '/access_blocked',
  '/already_signed',
  '/404',
  '/422',
  '/500',
  '/login',
  '/proxy',
  '/checkin_poster',
  '/checkin/[checkinOrganizationId]/entry',
  '/checkin/[checkinOrganizationId]/result/[checkinEntryId]',
  '/checkin/404',
  '/materials/bookmarked_manual',
  '/materials/basic_operation_manual',
  '/materials/docomo_app_campaign_manual',
  '/materials/404',
  '/followup_messages/[publicFollowupMessageId]/questionnaire_sheet',
  '/followup_messages/404',
  '/company',
  '/online/[sessionId]',
  '/online_demo',
  '/dispensing_request_preview/[nodeId]',
  '/prescription_preview/[appointmentId]',
  '/medicinenote/patients/[patientId]',
  '/medicinenote/onetime_codes/[onetimeCode]',
  '/insurance_card_preview/[patientId]',
  '/tracing_report_preview',
  '/uber_signature_preview',
  '/outpatient_questionnaire/[outpatientQuestionnaireOrganizationId]/entry',
  '/outpatient_questionnaire/[outpatientQuestionnaireOrganizationId]/result/[outpatientQuestionnaireEntryId]',
  '/outpatient_questionnaire/404',
  '/outpatient_questionnaire_sheet_preview/[outpatientQuestionnaireEntryId]',
  '/patient_authentication/[signupPfPatientInformationId]/authentication_code',
  '/patient_authentication/[signupPfPatientInformationId]/completed',
  '/patient_authentication/404',
];

export const useSetupIntercom = () => {
  const { pathname } = useRouter();
  const ignore = IGNORE_PATHNAME.includes(pathname);
  const setIntercomUnreadCountState = useSetAtom(intercomUnreadCountState);
  const handleUnreadCountChange = useCallback(
    (unreadCount: number) => {
      setIntercomUnreadCountState({ unreadCount });
    },
    [setIntercomUnreadCountState],
  );

  return {
    handleUnreadCountChange,
    ignore,
  };
};
